<div class="table-w-dropdown-container" [style.marginTop]="data?.marginTop">
  <h3 class="table-title" *ngIf="data?.title">{{ data?.title }}</h3>

  <div class="table-actions" *ngIf="showAddRowButton">
    <button type="button" class="add-row-button" (click)="onAddRowClick($event)">
      {{ addRowButtonLabel }}
    </button>
  </div>

  <div class="table-shell">
    <table mat-table [dataSource]="dataSource" class="discount-table"
      [class.terms-conditions-table]="data?.widgetId === 'termsAndConditionsTable'"
      [class.quote-level-discount-table]="data?.widgetId === 'quoteLevelDiscountTable'">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th class="header-cell" [ngClass]="getHeaderCellClasses(column)" [attr.data-column-key]="column" mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <span class="header-text">{{ formatHeaderLabel(columnLabels[column]) }}</span>
            <button
              *ngIf="canToggleColumnEdit(column)"
              type="button"
              class="header-edit-toggle"
              [class.active]="isColumnEditEnabled(column)"
              (click)="toggleColumnEdit(column, $event)"
              [attr.aria-label]="isColumnEditEnabled(column) ? 'Disable edit mode' : 'Enable edit mode'">
              <mat-icon>{{ isColumnEditEnabled(column) ? 'check' : 'edit' }}</mat-icon>
            </button>
          </div>
        </th>

        <td class="body-cell" [ngClass]="getBodyCellClasses(column, row)" [attr.data-column-key]="column" mat-cell *matCellDef="let row; let rowIndex = index">
          <ng-container *ngIf="isDropdownColumn(column) && isColumnEditable(column); else nonDropdownCell">
            <mat-form-field appearance="outline" class="dropdown-field"
              [class.compact-dropdown]="isCompactColumn(column)"
              [class.numeric-dropdown]="isNumericColumn(column, row)">
              <mat-select [multiple]="isMultiSelect(column)" [ngModel]="row[column]"
                (ngModelChange)="onDropdownChange(row, column, $event)"
                [placeholder]="dropdownColumnConfig[column]?.placeholder || 'Select'">
                <mat-option *ngFor="let option of getDropdownOptions(row, column)" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <ng-template #nonDropdownCell>
            <ng-container *ngIf="isInputColumn(column) && isColumnEditable(column); else textCell">
              <mat-form-field appearance="outline" class="input-field"
                [class.compact-input]="isCompactColumn(column)"
                [class.numeric-input]="isNumericColumn(column, row)">
                <input matInput [type]="getInputType(column, row)"
                  [attr.inputmode]="isNumericColumn(column, row) ? 'decimal' : null"
                  [ngModel]="getInputDisplayValue(column, row[column], row)"
                  (ngModelChange)="onTextInputChange(row, column, $event)"
                  [placeholder]="getInputPlaceholder(column)" />
              </mat-form-field>
            </ng-container>
            <ng-template #textCell>
              <ng-container *ngIf="isButtonColumn(column, row); else defaultTextCell">
                <button
                  type="button"
                  class="cell-action-button"
                  [class.completed]="isCellButtonCompleted(row, column, rowIndex)"
                  [class.rejected]="isCellButtonRejected(row)"
                  [disabled]="isCellButtonDisabled(row, column, rowIndex)"
                  (click)="onActionButtonClick(row, column, rowIndex, $event)">
                  {{ getButtonLabel(column, row, rowIndex) }}
                </button>
              </ng-container>
              <ng-template #defaultTextCell>
                <ng-container *ngIf="isCellApiClickable(column, row); else plainCellValue">
                  <button
                    type="button"
                    class="cell-link-button"
                    (click)="onCellValueClick(row, column, $event)">
                    {{ getCellDisplayValue(column, row[column], row) }}
                  </button>
                </ng-container>
                <ng-template #plainCellValue>
                  {{ getCellDisplayValue(column, row[column], row) }}
                </ng-template>
              </ng-template>
            </ng-template>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div class="table-footer-line" *ngIf="shouldShowFooterLine">
    <div class="table-footer-separator"></div>
    <h4 class="table-footer-text">
      {{ footerLineText }}
    </h4>
  </div>
</div>

<div class="popup-backdrop" *ngIf="isPopupOpen" (click)="closePopup()">
  <div class="popup-card" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">{{ popupTitle }}</h4>
      <div class="popup-header-actions">
        <button *ngIf="showPopupApproveButton" type="button" class="popup-approve-button"
          [disabled]="popupApproving"
          [class.approving]="popupApproving"
          (click)="onPopupApproveClick()">
          {{ popupApproving ? 'Approving...' : popupApproveLabel }}
        </button>
        <button type="button" class="popup-close-button" (click)="closePopup()">Close</button>
      </div>
    </div>

    <div class="popup-content">
      <div class="popup-loading" *ngIf="popupLoading">{{ popupLoadingMessage }}</div>
      <div class="popup-error" *ngIf="!popupLoading && popupError">{{ popupError }}</div>

      <div class="popup-summary-grid" *ngIf="!popupLoading && !popupError && popupSummaryFields.length > 0">
        <div *ngFor="let field of popupSummaryFields" class="popup-summary-item">
          <span class="popup-summary-label">{{ field.label }}</span>
          <span class="popup-summary-value">{{ popupSummaryData[field.key] }}</span>
        </div>
      </div>

      <div class="popup-table-shell" *ngIf="!popupLoading && !popupError">
        <table mat-table [dataSource]="popupRows" class="popup-table" *ngIf="popupRows.length > 0 && popupColumns.length > 0">
          <ng-container *ngFor="let column of popupColumns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef class="popup-header-cell">
              {{ popupColumnLabels[column] || formatHeaderLabel(column) }}
            </th>
            <td mat-cell *matCellDef="let row" class="popup-body-cell">
              {{ getPopupCellDisplayValue(row, column) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="popupColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: popupColumns"></tr>
        </table>

        <div class="popup-empty" *ngIf="popupRows.length === 0 || popupColumns.length === 0">
          {{ popupEmptyMessage }}
        </div>
      </div>

      <div class="popup-footer-summary" *ngIf="!popupLoading && !popupError && popupFooterFields.length > 0">
        <div *ngFor="let field of popupFooterFields" class="popup-footer-item">
          <span class="popup-footer-label">{{ field.label }}</span>
          <span class="popup-footer-value">{{ popupFooterData[field.key] }}{{ field.suffix || '' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
